// Which call a client is connected to. Games and the AI-coach debrief have a room per team and activity, the
// introduction and the group reflection one room for the whole sprint; everything else is the shared team call.
export enum WherebyCallKind {
  GAME = 'game',
  AI_COACH = 'ai-coach',
  TEAM = 'team',
  SPRINT = 'sprint'
}

// The kinds that run in their own room, so a call can be pinned to (and resumed on) their page.
export type WherebyDedicatedCallKind = WherebyCallKind.GAME | WherebyCallKind.AI_COACH

// What a stored room was opened for: one team's activity, a team's own call, or one activity of a whole sprint.
export enum WherebyMeetingType {
  ACTIVITY = 'activity',
  TEAM = 'team',
  SPRINT = 'sprint'
}

// Outcome of asking for the user's single allowed Whereby connection.
export enum WherebyCallClaimStatus {
  GRANTED = 'granted',
  BLOCKED = 'blocked'
}

// What a call surface is allowed to do right now (client-side state machine).
export enum WherebyCallOwnershipStatus {
  /** Not asking for the call (disabled, or no scope resolved yet). */
  IDLE = 'idle',
  /** Asking the server. */
  CLAIMING = 'claiming',
  /** We hold the user's single allowed call — safe to join the room. */
  CONNECTED = 'connected',
  /** Another live tab/device of this user holds it. Needs the user's explicit confirmation to move. */
  BLOCKED = 'blocked',
  /** Another call surface in THIS tab already holds it — nothing to confirm. */
  BLOCKED_IN_TAB = 'blocked-in-tab',
  /** We could not verify ownership. Never connect on this — that is how you end up in two calls. */
  ERROR = 'error'
}

// Browser SDK room states mirrored exactly so application lifecycle checks stay typed.
export enum WherebyRoomConnectionStatus {
  READY = 'ready',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  ROOM_LOCKED = 'room_locked',
  KNOCKING = 'knocking',
  KNOCK_ON_HOLD = 'knock_on_hold',
  KNOCK_REJECTED = 'knock_rejected',
  KICKED = 'kicked',
  LEAVING = 'leaving',
  LEFT = 'left',
  DISCONNECTED = 'disconnected',
  RECONNECTING = 'reconnecting'
}

// The buttons of the call surface's toolbar.
export enum WherebyToolbarButtonId {
  CAMERA = 'camera',
  MICROPHONE = 'microphone',
  SCREENSHARE = 'screenshare',
  PEOPLE = 'people',
  SETTINGS = 'settings',
  LEAVE = 'leave'
}

// View rendered by the floating Whereby card, or the sprint call page, before or after room initialization.
export enum WherebyFloatCardView {
  ASK = 'ask',
  CALL = 'call',
  PREPARING = 'preparing'
}

// Whereby service clients that must not count as human call participants.
export enum WherebyBotRoleName {
  RECORDER = 'recorder',
  CAPTIONER = 'captioner',
  TRANSCRIBER = 'transcriber',
  STREAMER = 'streamer'
}
